module.exports = __webpack_public_path__ + "static/media/banh-mi-noodles.d033f8ce.png";